import { useSelector } from "react-redux";
import { selectCurrentClientId } from "../../features/client/clientSlice";
import { useGetClientByIdQuery } from "../../features/client/clientApiSlice";
import { useClientPopulate } from "./useClientPopulate";
import { useCallback, useEffect } from "react";
import { skipToken } from "@reduxjs/toolkit/query";

export const useClientPopulateWrap = () => {
    
    const clientId = useSelector(selectCurrentClientId);
    const { data: clientInfo, isLoading: isLoadingClientInfo, isFetching: isFetchingClientInfo, refetch: refetchClientInfo, error, fulfilledTimeStamp } = useGetClientByIdQuery( clientId ?? skipToken, { refetchOnMountOrArgChange: true,})

    const {
        populateClientInfo,
        populateHeritageInformation,
        populateChapel,
        populateAdditionalInfo,
        populateExtraPackages,
    } = useClientPopulate(clientInfo)

    const repopulateAll = useCallback(() => {
        populateClientInfo()
        populateHeritageInformation()
        populateChapel()
        populateAdditionalInfo()
        populateExtraPackages()
    }, [
        populateClientInfo,
        populateHeritageInformation,
        populateChapel,
        populateAdditionalInfo,
        populateExtraPackages,
    ])

    useEffect(() => {
        if (!clientInfo?.clientID) return;
        repopulateAll()
    }, [fulfilledTimeStamp])

    return {
        clientInfo,
        isLoadingClientInfo,
        repopulateAll,
        populateClientInfo,
        populateHeritageInformation,
        populateChapel,
        populateAdditionalInfo,
        populateExtraPackages,
    }
}